export default __webpack_public_path__ + "static/media/appleStore.37bd6f61.svg";